import React from 'react';

const Value = props => {
   const { icon, content } = props;

   return (
      <div className="align-center">
         <img src={icon} width={35} alt="icon" />
         <p>{content}</p>
      </div>
   );
};

export default Value;



// WEBPACK FOOTER //
// ./src/components/About/value.js